import { STORAGE_KEYS } from 'shared/constants/storage';
import { getItem } from 'shared/utils/asyncStorage';
import {
  handleFetchError,
  handleNetworkError,
  isBaseNetworkError,
} from 'shared/utils/errors';

const authenticatedFetch = async (
  url: string,
  options?: RequestInit,
): Promise<Response> => {
  const headers = {
    ...options?.headers,
    'Content-Type': 'application/json',
  };

  // eslint-disable-next-line @typescript-eslint/dot-notation -- tsc requires bracket access on HeadersInit union
  if (!options?.headers || !options.headers['Authorization']) {
    const token = await getItem(STORAGE_KEYS.ID_TOKEN);
    // eslint-disable-next-line @typescript-eslint/dot-notation -- tsc requires bracket access here
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, { ...options, headers });

    if (!response.ok) {
      await handleFetchError(response);
    }

    return response;
  } catch (error) {
    if (isBaseNetworkError(error)) {
      throw error; // already classified by handleFetchError
    }
    return handleNetworkError(error);
  }
};

export default authenticatedFetch;
